import styled from 'styled-components';
import React from 'react';
import { Popover } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const StyledLabel = styled.label`
    width: 15%;
    display: inline-block;
    font-size: 1.6em;
    text-align: center;
`;

const TooltipIcon = styled(QuestionCircleOutlined)`
    vertical-align: top;
    margin-top: 0.3em;
    margin-left: 0.5em;
`;

const OutputLabel = ({ text = '', tooltip = null, style = {} }) => (
    <StyledLabel style={style}>
        {text}
        {tooltip && (
            <Popover placement="right" content={tooltip} trigger="click">
                <TooltipIcon />
            </Popover>
        )}
    </StyledLabel>
);

export default OutputLabel;
